let profile
try {
  profile = JSON.parse(window.localStorage.getItem('profile'))
} catch (e) {
  profile = null
}

let addresses
try {
  addresses = JSON.parse(window.localStorage.getItem('addresses'))
} catch (e) {
  addresses = null
}

export default {
  token: window.localStorage.getItem('client_token') || null,
  profile,
  menu_plans: null,
  demo_mode: false,
  addresses,
  faq: null,
  // 1 - show, 2 - dont
  showOnboardings: +window.localStorage.getItem('show_onboardings') !== 2,
  unauthorizedImtData: {},
  preloadedMenus: null,
}
